import createTableStore from "ds/components/Table/store/useTableStore";

import { SPACE_IDP_GROUPS_COLUMN_CONFIG, SPACE_IDP_GROUPS_COLUMNS_STORAGE_KEY } from "./constants";

const useSpaceDetailsIdpGroupsTableStore = createTableStore({
  storageKey: SPACE_IDP_GROUPS_COLUMNS_STORAGE_KEY,
  config: SPACE_IDP_GROUPS_COLUMN_CONFIG,
});

export default useSpaceDetailsIdpGroupsTableStore;
